const appConfig = {
  basename: '',
  baseUrl: process.env.REACT_APP_BASE_URL,
  customization: {
    fontFamily: '\'Roboto\', sans-serif',
    borderRadius: 20,
  },
  routes: {
    basePath: '/',
    homePath: '/app/home',
    loginPath: '/login',
    signupPath: '/signup',
    usersPath: '/app/users',
    loansPath: '/app/loans',
    ordersPath: '/app/orders',
    resetPath: '/reset',
    setPassword: '/admin/password',
    adminsPath: '/app/admins',
    inviteAdminsPath: '/app/admins/invite',
    emailSentPath: '/emailSent',
    transactionsPath: '/app/transactions',
    settingsPath: '/app/settings',
    confirmEmailPath: '/admin/confirmEmail',
  },
  pagination: {
    pageSize: 10,
  },
};

export default appConfig;
